module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-title"
  }, [_c('div', [_c('span', {
    staticClass: "title-kh-1"
  }, [_vm._v("》")]), _c('span', {
    staticClass: "title-kh-2"
  }, [_vm._v("》")]), _c('span', [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), (_vm.rightText) ? _c('div', {
    staticClass: "right-text"
  }, [_vm._v("\n    " + _vm._s(_vm.rightText) + "\n  ")]) : _vm._e(), _vm._v(" "), (_vm.searchInput) ? _c('div', {
    staticClass: "right-text"
  }, [_c('el-input', {
    staticStyle: {
      "width": "10rem"
    },
    attrs: {
      "size": "mini",
      "placeholder": "",
      "icon": "search"
    },
    model: {
      value: (_vm.inputValue),
      callback: function($$v) {
        _vm.inputValue = $$v
      },
      expression: "inputValue"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.actions) ? _c('div', {
    staticClass: "title-menus"
  }, _vm._l((_vm.actions), function(action) {
    return _c('a', {
      attrs: {
        "href": "javascript:;"
      }
    }, [_c('i', {
      staticClass: "iconfont",
      class: action.icon,
      on: {
        "click": function($event) {
          _vm.clickMenu(action.key)
        }
      }
    })])
  })) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0695f2fa","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components_bit/ContentTitle.vue
// module id = 950
// module chunks = 1